import Image from 'next/image';

function QuoteIcon({ className }) {
    return (
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
            <path d="M11.192 15.757c0-.88-.23-1.618-.69-2.217-.326-.412-.768-.683-1.327-.812-.55-.128-1.07-.137-1.54-.028-.16-.95.077-1.928.71-2.932.633-1.003 1.538-1.97 2.717-2.898L9.186 5c-1.47.964-2.694 2.14-3.672 3.528C4.536 9.914 4.047 11.31 4.047 12.7c0 1.17.353 2.135 1.06 2.895.705.76 1.63 1.14 2.773 1.14 1.02 0 1.868-.328 2.544-.986.676-.658 1.014-1.48 1.014-2.47l-.246.478zm9.027 0c0-.88-.23-1.618-.69-2.217-.326-.42-.77-.692-1.327-.817-.56-.124-1.074-.13-1.54-.022-.16-.94.076-1.916.71-2.927.634-1.01 1.538-1.975 2.717-2.896L18.213 5c-1.47.964-2.695 2.14-3.672 3.528-.978 1.386-1.467 2.782-1.467 4.172 0 1.17.353 2.135 1.06 2.895.705.76 1.63 1.14 2.773 1.14 1.02 0 1.868-.328 2.544-.986.676-.658 1.013-1.48 1.013-2.47l-.245.478z" />
        </svg>
    );
}

export function Testimonial({ quote, name, jobTitle, company, identifier }) {
    return (
        <div
            className="bg-blue-800 py-16 md:py-24"
            style={{
                backgroundImage:
                    'radial-gradient(ellipse 70% 60% at 50% 50%, rgba(182,38,232,0.18) 0%, transparent 70%), linear-gradient(rgba(182,38,232,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(182,38,232,0.1) 1px, transparent 1px)',
                backgroundSize: 'auto, 48px 48px, 48px 48px'
            }}>
            <div className="container mx-auto max-w-3xl text-center">
                <QuoteIcon className="mx-auto mb-6 size-10 text-fuschia-400 opacity-80" />

                <blockquote className="text-xl italic leading-relaxed text-white md:text-2xl">
                    {quote}
                </blockquote>

                <QuoteIcon className="mx-auto mt-6 size-10 rotate-180 text-fuschia-400 opacity-80" />

                <div className="mt-10 flex flex-col items-center gap-3">
                    <div className="size-16 overflow-hidden rounded-full ring-2 ring-fuschia-700/50">
                        <Image
                            src={`/dA/${identifier}/image`}
                            width={64}
                            height={64}
                            sizes="64px"
                            quality={65}
                            className="size-full object-cover"
                            alt={name ?? 'Testimonial'}
                        />
                    </div>
                    <div className="text-center">
                        <p className="font-semibold text-white">{name}</p>
                        <p className="text-sm text-gray-400">
                            {jobTitle}, {company}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
